<template>
  <div>
    <el-row :gutter="6">
      <el-col class="col_content" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <el-card shadow="hover" class="card_content">
          <div @click="to_cart" slot="header" class="header_card">
            <div class="header_card_content">
              <i class="icon_el el-icon-truck"></i>
              <div class="h2_el">
                <h2>冷链车</h2>
                <span>REFRIGERATED TRUCK</span>
              </div>
            </div>
            <div class="header_card_bottom">
              <span>全部 <span>{{truck_data_total}}</span></span>
            </div>
          </div>
          <!-- 冷链车列表 -->
          <el-table
          v-loading="list_loading"
          highlight-current-row
          :data="truck_data"
          height="450"
          :row-class-name="truck_row_class_name"
          @row-click="truck_row_click"
          >
            <el-table-column
            align="center"
            prop="vehicleNo"
            label="车牌号"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="gpsTime"
            label="定位时间"
            ></el-table-column>
            <el-table-column
            align="center"
            :label="item"
            :key="index"
            v-for="(item,index) in point_list"
            >
              <template slot-scope="scope">
                <span>{{scope.row.tempData[index]?scope.row.tempData[index].pointValue:''}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col class="col_content" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <el-card shadow="hover" class="card_content">
          <div @click="to_temp" slot="header" class="header_card">
            <div class="header_card_content">
              <i style="font-size: 45px;" class="iconfont icon_el icon-wendu"></i>
              <div class="h2_el">
                <h2>温度记录仪</h2>
                <span>TEMPERATURE RECORDER</span>
              </div>
            </div>
            <div class="header_card_bottom">
              <span>全部 <span>{{temp_data_total}}</span></span>
            </div>
          </div>
          <!-- 温度记录仪列表 -->
          <el-table
          v-loading="list_loading"
          highlight-current-row
          :data="temp_data"
          height="450"
          :row-class-name="temp_row_class_name"
          @row-click="temp_row_click"
          >
            <el-table-column
            align="center"
            prop="deviceId"
            label="编号"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="deviceValue"
            label="温度(℃)"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="at"
            label="时间"
            ></el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col class="col_content" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <el-card shadow="hover" class="card_content">
          <div @click="to_cold_storage" slot="header" class="header_card">
            <div class="header_card_content">
              <i style="font-size: 45px;" class="iconfont icon_el icon-kucunguanli2"></i>
              <div class="h2_el">
                <h2>库房</h2>
                <span>COLD STORAGE</span>
              </div>
            </div>
            <div class="header_card_bottom">
              <span>库区 <span>{{area_data.totalArea}}</span></span>
              <span>探头 <span>{{area_data.totalPoint}}</span></span>
            </div>
          </div>
          <!-- 库房列表 -->
          <el-row v-loading="list_loading" :gutter="6">
            <el-col
            v-for="(item,index) in area_data.areaData"
            :key="index"
            class="col_content"
            :span="12">
              <el-card style="height: 340px;overflow-y: auto;" shadow="hover" class="storage_card">
                <div slot="header" class="storage_header">
                  <span @click="warehouse_to_manage(item.warehouseId,'','')">仓库名称：{{item.warehouseName}}</span>
                  <span @click="warehouse_to_manage(item.warehouseId,item.areaId,'')">区域名称：{{item.areaName}}</span>
                </div>
                <div class="storage_content">
                  <div v-for="(item1,index1) in item.detail" style="margin-bottom: 5px;">
                    <span @click="warehouse_to_manage(item.warehouseId,item.areaId,item1.pointName)">{{item1.pointName}}:{{item1.pointValue}}</span>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import router from '../../router'
  export default{
    data() {
      return{
        //列表懒加载
        list_loading:false,
        //冷链车列表
        //温度点列表
        point_list:['温度1(℃)','温度2(℃)'],
        truck_data:[],
        //冷链车列表长度
        truck_data_total:0,
        //温度记录仪列表
        temp_data:[],
        //温度记录仪列表长度
        temp_data_total:0,
        //库房列表
        area_data:[]
      }
    },
    created() {
      //获取数据总览
      this.get_data_view()
    },
    mounted() {

    },
    methods:{
      //获取数据总览
      get_data_view(){
        this.list_loading=true
        this.$axios({
          method:'get',
          url:this.publicAjax.extra_path+'/middle/overView/card'
        }).then(data=>{
          this.list_loading=false
          if(data.data.success==true){
            //冷链车列表
            this.truck_data=data.data.data.driveData
            if(this.truck_data!=null){
              this.truck_data_total=this.truck_data.length
            }
            //温度记录仪列表
            this.temp_data=data.data.data.realTimeData
            if(this.temp_data_total!=null){
              this.temp_data_total=this.temp_data.length
            }
            //库房列表
            this.area_data=data.data.data.warehousePointData
          }else{
            this.$message.warning(data.data.message)
          }
        })
      },
      //公共函数
      get_router(path,path_name,row){
        let router_list=[]
        this.$store.state.openTab.forEach((item,index)=>{
          router_list.push(item.route)
        })
        if(router_list.includes(path)){
          this.$store.commit('delete_tabs',path)
        }
        this.$store.commit('add_tabs',{
          route:path,
          name:path_name
        })
        this.$store.commit('set_active_index',path)
        this.$router.push({
          path:path,
          query:{
            row:row
          }
        })
      },
      truck_row_class_name({row,rowIndex}){
        row.index=rowIndex
      },
      temp_row_class_name({row,rowIndex}){
        row.index=rowIndex
      },
      //冷链车列表行内点击事件
      truck_row_click(row){
        this.get_router('/cold/truck_detail','冷链车监控详情',row)
      },
      //温度记录仪列表行内点击事件
      temp_row_click(row){
        this.get_router('/cold/temp_detail','温度记录仪详情',row)
      },
      //跳转冷链车监控详情页面
      to_cart(){
        this.get_router('/cold/truck_detail','冷链车监控详情')
      },
      //跳转温度记录仪详情页面
      to_temp(){
        this.get_router('/cold/temp_detail','温度记录仪详情')
      },
      //跳转冷库监控详情页面
      to_cold_storage(){
        this.get_router('/cold/cold_storage_detail','冷库监控详情')
      },
      //跳转库房管理页面
      warehouse_to_manage(warehouseId,areaId,pointName){
        this.get_router('/cold/warehouse_manage','库房管理',{
          warehouseId:warehouseId,
          areaId:areaId,
          pointName:pointName
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .col_content{
    margin-bottom: 6px;
  }
  .card_content:hover{
    cursor: pointer;
    background: linear-gradient(to right,rgba(255,255,255,0.1),rgba(64, 158, 255,0.1));
    .h2_el h2{
      color: rgb(64, 158, 255);
    }
    .icon_el{
      color: rgb(64, 158, 255);
    }
  }
  .header_card_content{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .icon_el{
    display: inline-block;
    font-size: 50px;
    color: darkgray;
  }
  .h2_el{
    text-align: right;
  }
  .h2_el h2{
    font-size: 20px;
    font-weight: 600;
  }
  .h2_el span{
    display: block;
    color: darkgray;
    font-size: 12px;
  }
  .header_card_bottom{
    margin-top: 10px;
    display: flex;
    justify-content: space-around;
    font-size: 16px;
    font-weight: 100;
  }
  /* 冷链列表 */
  .storage_card:hover{
    cursor: pointer;
    background: linear-gradient(to right,rgba(255,255,255,0.1),rgba(64, 158, 255,0.1));
  }
  .storage_header span{
    display: block;
    margin-bottom: 5px;
  }
  .storage_header span:hover,
  .storage_content span:hover{
    color: rgba(64, 158, 255,0.5);
  }
  .storage_content span{
    margin-right: 5px;
    display: inline-block;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/device_view.vue